const PERMISSION_KEY= "core:tenant_admin_audit_log";
const PAGE_URL = {
    TENANT_ADMIN_AUDIT_LOG_PAGE: "/admin/core/tenant-admin-audit-log"
}

export {PERMISSION_KEY, PAGE_URL}

